module.exports = __webpack_public_path__ + "media/images/pepsi_home/pepsi_dig_in_day_icon-2cf969637af7b31d2f5d667830254339.svg";